import { useEffect, useState } from 'react'
import {
  Field,
  FieldProps as FormikFieldProps,
  FieldAttributes,
  ErrorMessage,
} from 'formik'
import { OnChangeValue, Options } from 'react-select'

import AsyncDropdown from 'components/Input/AsyncDropdown'
import { DropdownOption } from 'components/Input/Dropdown'
import { StyledDropdownError } from './styles'

export interface DropdownFieldProps extends FormikFieldProps {
  initialValue?: DropdownOption
  handleChange?: (option: DropdownOption) => void
  loadOptions: (inputValue: string) => Promise<Options<DropdownOption>>
  placeholder?: string
  isLoading?: boolean
  showLabel?: boolean
  disabled?: boolean
}

function AsyncDropdownDrawer({
  initialValue,
  field,
  form,
  loadOptions,
  placeholder,
  handleChange,
  isLoading,
  showLabel = false,
  disabled = false,
}: DropdownFieldProps) {
  const [value, setValue] = useState<DropdownOption>()

  useEffect(() => {
    if (initialValue) {
      setValue(initialValue)
    }
  }, [initialValue])

  const onChange = (
    option: OnChangeValue<DropdownOption | DropdownOption[], boolean>
  ) => {
    setValue(option as DropdownOption)
    form.setFieldValue(field.name, (option as DropdownOption).value)
    if (handleChange) {
      handleChange(option as DropdownOption)
    }
  }

  return (
    <AsyncDropdown
      name={field.name}
      value={value}
      onChange={onChange}
      loadOptions={loadOptions}
      placeholder={placeholder}
      showLabel={showLabel}
      isLoading={isLoading}
      disabled={disabled}
    />
  )
}

function AsyncDropdownField(props: FieldAttributes<any> & DropdownFieldProps) {
  return (
    <>
      <Field component={AsyncDropdownDrawer} {...props} />
      <StyledDropdownError>
        <ErrorMessage name={props.name} />
      </StyledDropdownError>
    </>
  )
}

export default AsyncDropdownField
